import { GiftIcon } from '../../../assets/icons/GiftIcon';
import { getDiscountDisplayData } from '../../../utils/discounts/getDiscountDisplayData';
import { getOfferBannerText } from '../../../utils/discounts/getOfferBannerText';

export type OfferBannerProps = {
  discountTerms: ReturnType<typeof getDiscountDisplayData>;
  show2MonthsPromotion?: boolean;
};

const styles = {
  banner:
    'flex flex-row items-center justify-center gap-space-400 py-space-400 px-space-600 rounded-radius-200 bg-success-100 text-text-success',
  icon: 'w-8 h-8 flex items-center justify-center shrink-0',
  text: 'text-body-large-strong text-text-success',
};

export const OfferBanner = ({ discountTerms, show2MonthsPromotion }: OfferBannerProps) => (
  <div className={styles.banner} role="banner">
    <span className={styles.icon}>
      <GiftIcon size={28} color="currentColor" />
    </span>
    <p className={styles.text}>{getOfferBannerText(discountTerms, show2MonthsPromotion)}</p>
  </div>
);
